import React, { Component } from "react";

class NoMessages extends Component {
  render() {
    return (
      <div className="noData noMessages">
        <div className="noDataTitle">There are no messages</div>
        <div className="noDataComment">
          It looks like you don't have messages yet.
        </div>
      </div>
    );
  }
}

export default NoMessages;



// WEBPACK FOOTER //
// ./src/components/utilities/NoMessages.js